/**
 * @description Enable pathways for logged in users
 */
export const showPathwaysUserBased = () => {
  return true;
};
